import { Stack, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useTermsOfServiceBox } from '../hooks/useTermsOfServiceBox';

type TermsOfServiceBoxProps = {
  canAgree: boolean;
  setCanAgree: Dispatch<SetStateAction<boolean>>;
};

export const TermsOfServiceBox = ({ canAgree, setCanAgree }: TermsOfServiceBoxProps) => {
  const { t } = useTranslation();
  const { termsRef, handleTermsScroll } = useTermsOfServiceBox({ canAgree, setCanAgree });

  return (
    <Stack
      ref={termsRef}
      onScroll={handleTermsScroll}
      sx={{
        height: '200px',
        overflowY: 'auto',
        bgcolor: 'grey.100',
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}>
      <Typography variant="h6" gutterBottom>
        {t('idIssuance.termsOfService.section1.title')}
      </Typography>
      <Typography paragraph>{t('idIssuance.termsOfService.section1.paragraph1')}</Typography>
      <Typography paragraph>{t('idIssuance.termsOfService.section1.paragraph2')}</Typography>

      <Typography variant="h6" gutterBottom>
        {t('idIssuance.termsOfService.section2.title')}
      </Typography>
      <Typography paragraph>{t('idIssuance.termsOfService.section2.paragraph1')}</Typography>
      <Typography>{t('idIssuance.termsOfService.section2.paragraph2')}</Typography>
      <Typography component="div" sx={{ pl: 3 }}>
        <Typography>{t('idIssuance.termsOfService.section2.paragraph3.item1')}</Typography>
        <Typography>{t('idIssuance.termsOfService.section2.paragraph3.item2')}</Typography>
        <Typography>{t('idIssuance.termsOfService.section2.paragraph3.item3')}</Typography>
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        {t('idIssuance.termsOfService.section3.title')}
      </Typography>
      <Typography paragraph>{t('idIssuance.termsOfService.section3.paragraph1')}</Typography>
      <Typography paragraph>{t('idIssuance.termsOfService.section3.paragraph2')}</Typography>
    </Stack>
  );
};
